// Contacts and users are separate DTOs that both carry a name, hence the structural type.
interface NamedPerson {
  firstName?: string | null;
  lastName?: string | null;
}

// Joins the parts a person actually has, so a mononymous record doesn't render a trailing space.
export function formatFullName(person: NamedPerson): string {
  return [person.firstName, person.lastName].filter(Boolean).join(" ");
}
